import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import customTheme from '../styles/theme'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from "@material-ui/core/styles";
import Header from './Header'
import {useEffect} from 'react'
import { Provider } from 'react-redux';
import store from '../store';
import {
    Router,
    Switch,
    Route,
    Redirect
} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { reserveRoutes, reserveHistoryRoute } from '../router/routeConfig'
import { fetchInitialOptions } from '../actions'
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {history} from '../router/history'
import twLocale from "date-fns/locale/zh-TW";

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.secondary.light,
        minHeight: "100vh"
    }
}))


function App() { 

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={twLocale}>
            <Provider store={store}>
                <ThemeProvider theme={customTheme}>
                    <CssBaseline />
                    <Main />
                </ThemeProvider>
            </Provider>
        </MuiPickersUtilsProvider>
    );
}

function Main() {
    
    const classes = useStyles()

    const dispatch = useDispatch()

    useEffect(() => {

        dispatch(fetchInitialOptions())
        
    }, [dispatch])
  
    return (
        <Container maxWidth="xl" className={classes.container} disableGutters>           
            <Router history={history}>
                <Header />
                <Grid container justify="center">
                    <Grid item xl={6} lg={8} md={8} sm={12} xs={12}>
                
                        <Switch>
                            <Route exact path="/">
                                <Redirect to={reserveRoutes[0].path} />
                            </Route>
                            {reserveRoutes.map((route) => (
                                <Route 
                                exact 
                                path={route.path} 
                                key={route.path}
                                render={props => (                           
                                    <route.component {...props} />
                                )}
                                />                                           
                            ))}
                            {reserveHistoryRoute.map((route) => (
                                <Route 
                                exact 
                                path={route.path} 
                                key={route.path}
                                render={props => (                           
                                    <route.component {...props} />
                                )}
                                />                                           
                            ))}
                        </Switch>
                    </Grid>
                </Grid>                
                
            </Router>
        </Container>
    );
}

export default App;
